// Libraries
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider, closeSnackbar } from 'notistack';
import { CookiesProvider } from 'react-cookie';
import { Provider } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';

// MUI
// Core
// Common
import ViewLoader from './common/ViewLoader';

// Interfaces
// Store
import store from './store/store';

// API
// Feature
import App from './App';
import './index.css';
import './i18n';
import { IconButton } from '@mui/material';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    // <StrictMode> EditorJS is not working with strict mode. Discovered on http://jira.mtech.fi/browse/AN-1979 and by some fella over https://github.com/Jungwoo-An/react-editor-js/issues/228
    <Provider store={store}>
        <CookiesProvider>
            <Suspense fallback={<ViewLoader />}>
                <SnackbarProvider
                    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                    maxSnack={5}
                    action={(snackbarId) => (
                        <IconButton
                            onClick={() => closeSnackbar(snackbarId)}
                            size='small'
                            color='inherit'
                            aria-label='close'
                        >
                            <CloseIcon fontSize='small' />
                        </IconButton>
                    )}
                >
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </SnackbarProvider>
            </Suspense>
        </CookiesProvider>
    </Provider>
    // </StrictMode>
);
